<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ formData.title }}</h2>
                </v-row>

                <v-container id="scroll-target" class="custom-form px-5 pb-4">
                    <div>
                            <v-subheader class="blue--text">{{$t('reportsparam.parameters')}}</v-subheader>
                            <v-row>
                                <v-col cols="4" sm="4" class="pb-n5 ">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('reportsparam.asatdate')"
                                        type="date"
                                        id="asatdate"
                                        v-model="formData.asatdate"
                                        dense                                
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="2" sm="2" class="pb-n5 mt-1">
                                    <v-checkbox 
                                    input-value="true"
                                    :label="this.$t('reportstaffenquiry.activestaff')"
                                    v-model="activeStaff"
                                    value
                                    ></v-checkbox>
                                </v-col>
                            </v-row>

                    </div>
                </v-container>

                <v-row class="pl-6 pt-4 pb-4">
                    <v-btn color="warning" style="width: 100px" @click="goHandler">
                        {{$t('button.go')}}
                    </v-btn>
                </v-row>
            </v-form>
        </v-container>
    </div>
</template>

<script>
export default {

    data() {
        return{
            formData:{
                asatdate: new Date().toISOString().slice(0,10),
                title: this.$t('staffenquiry'),
                uservalvalueid: null,
                usergrptypeid: null,
            },

            activeStaff: true,
        }
    },

    methods: {
         goHandler() {

            if(this.activeStaff === true) {
                this.$router.push({name: 'staffenquirydetails', params: { asatdate: this.formData.asatdate, activedate: this.formData.asatdate, uservalvalueid: this.formData.uservalvalueid, usergrptypeid: this.formData.usergrptypeid } });
            } else {
                this.$router.push({name: 'staffenquirydetails', params: { asatdate: this.formData.asatdate, uservalvalueid: this.formData.uservalvalueid, usergrptypeid: this.formData.usergrptypeid} });
            }
            
        },

        loadUserGroupAccess(){
            const vm = this;
            this.$store.dispatch('get', {url: "/dataaccess/group/" + this.$store.getters.userId})
            .then((res) => {
                const valvalueIds = [];
                const grptypeIds = [];

                for (let i = 0; i < res.data.rec.length; i++) {
                    const item = res.data.rec[i];

                    // Collect all valvalueid and grptypeid
                    valvalueIds.push(item.valvalueid);
                    grptypeIds.push(item.grptypeid);
                }

                // Assign comma-separated string to uservalvalueid and usergrptypeid
                this.formData.uservalvalueid = valvalueIds.join(',');
                this.formData.usergrptypeid = grptypeIds.join(',');

                console.log("USER GROUPVALUE", this.formData.uservalvalueid);
                console.log("USER GROUPVALUE", this.formData.usergrptypeid);
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        }
    },

    mounted(){
        this.loadUserGroupAccess();
    }
}
</script>